export const DIAMETER_BUCKET_MAX = 9999 as const

/**
 * Diameter bands used by the reports and the map legend, matching the bands
 * used in the reports delivered to customers.
 */
export const DIAMETER_METRIC_BOUNDARIES = [0, 50, 75, 100, 150, 200, 250, 300] as const

export const DIAMETER_IMPERIAL_BOUNDARIES = [0, 2, 3, 4, 6, 8, 10, 12] as const
